import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material';
import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { useState } from 'react';

import { useSubmitData } from '../../../../../hooks/useSubmitData';
import { rejectAdsAction } from '../../../../../api';
import { getSelectedIndustryId } from '../../../../../utils/industryUtils';

export const RejectButton = () => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const { submit, loading } = useSubmitData(rejectAdsAction);

  if (!record) return null;

  const handleOpen = () => {
    setReason('');
    setOpen(true);
  };

  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleReject = async () => {
    try {
      await submit({ id: record.id, industry_id: getSelectedIndustryId(), reason: reason.trim() });
      notify('Action rejected', { type: 'info' });
      setOpen(false);
      refresh();
    } catch (error) {
      notify(error.message, { type: 'error' });
    }
  };

  return (
    <>
      <MuiButton
        onClick={handleOpen}
        variant="contained"
        color="error"
        disabled={record.status !== 'proposed'}
      >
        Reject
      </MuiButton>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Reject action #{record.id}</DialogTitle>
        <DialogContent>
          <TextField
            label="Reason"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            required
            multiline
            minRows={3}
            fullWidth
            autoFocus
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={handleReject}
            variant="contained"
            color="error"
            disabled={!reason.trim() || loading}
          >
            Reject
          </MuiButton>
          <MuiButton onClick={handleClose} color="primary" disabled={loading}>Cancel</MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
